import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { getServiceBySlug } from "../servicesData";
import SingleServiceHero from "../components/services/SingleServiceHero";
import WhatsIncluded from "../components/services/WhatsIncluded";
import HowItWorks from "../components/services/HowItWorks";
import ServiceReleasePricing from "../components/services/ServiceReleasePricing";
import Accordion from "../components/shared/Accordion";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = getServiceBySlug(slug);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return (
    <>
      <SingleServiceHero service={service} />
      <WhatsIncluded items={service.whatsIncluded} />
      <HowItWorks steps={service.howItWorks} />
      <ServiceReleasePricing headline={service.pricingHeadline} options={service.pricingOptions} />
      <section className="mu-section">
        <div className="container">
          <div className="mb-4">
            <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>Questions</div>
            <h2 className="section-title">{service.faqHeading}</h2>
          </div>
          <Accordion items={service.faq} />
        </div>
      </section>
    </>
  );
}
